import React from 'react';
import ContentMixin from './content-mixin.js'
import LevelMixin from './level-mixin.js'
import Tools from './tools.js'

export const SectionMixin = {

  //@@viewOn:mixins
  mixins: [ContentMixin, LevelMixin],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    UU5_Common_SectionMixin: {
      requiredMixins: ['UU5_Common_BaseMixin', 'UU5_Common_ContentMixin', 'UU5_Common_LevelMixin'],
      defaults: {
        headerTag: 'UU5.Bricks.Header',
        footerTag: 'UU5.Bricks.Footer'
      }
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    header: React.PropTypes.oneOfType([
    // content body:[{tag:'',props:{}},{tag:'',props:{}},...]
    React.PropTypes.arrayOf(React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      props: React.PropTypes.object
    })),
    // content bodyItem:{tag:'',props{}}
    React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      props: React.PropTypes.arrayOf(React.PropTypes.object)
    }),
    // content items:{tag:'',propsArray:[{},{},{},...]}
    React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      propsArray: React.PropTypes.arrayOf(React.PropTypes.object)
    }),
    // content node
    React.PropTypes.node,
    // element
    React.PropTypes.shape({
      element: React.PropTypes.oneOfType([React.PropTypes.element, React.PropTypes.shape({
        tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
        props: React.PropTypes.object
      })])
    })]),
    footer: React.PropTypes.oneOfType([
    // content body:[{tag:'',props:{}},{tag:'',props:{}},...]
    React.PropTypes.arrayOf(React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      props: React.PropTypes.object
    })),
    // content bodyItem:{tag:'',props{}}
    React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      props: React.PropTypes.arrayOf(React.PropTypes.object)
    }),
    // content items:{tag:'',propsArray:[{},{},{},...]}
    React.PropTypes.shape({
      tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
      propsArray: React.PropTypes.arrayOf(React.PropTypes.object)
    }),
    // content node
    React.PropTypes.node,
    // element
    React.PropTypes.shape({
      element: React.PropTypes.oneOfType([React.PropTypes.element, React.PropTypes.shape({
        tag: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
        props: React.PropTypes.object
      })])
    })])
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      header: null,
      footer: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    // initialize
    this.registerMixin('UU5_Common_SectionMixin');
    this.renderedHeaderChild = null; // renderedChild
    this.renderedFooterChild = null; // renderedChild
    // state
    return null;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  hasUU5_Common_SectionMixin: function () {
    return this.hasMixin('UU5_Common_SectionMixin');
  },

  getHeader: function () {
    return typeof this.getHeader_ === 'function' ? this.getHeader_() : this.props.header;
  },

  getFooter: function () {
    return typeof this.getFooter_ === 'function' ? this.getFooter_() : this.props.footer;
  },

  getHeaderType: function (headerContent) {
    var type = null; // one of ['contentOfStandardHeader','headerElement','headerBodyItem']
    if (headerContent) {
      if (typeof headerContent.element === 'object') {
        type = headerContent.element.tag ? 'headerBodyItem' : 'headerElement';
      } else if (typeof headerContent === 'string') {
        let uu5JsonRegExp = /(^<uu5json\/>)/;
        let match = uu5JsonRegExp.exec(headerContent);
        type = (match) ? 'uu5JSON' : 'contentOfStandardHeader';
      } else {
        type = 'contentOfStandardHeader';
      }
    }
    return type;
  },

  getFooterType: function (footerContent) {
    var type = null; // one of ['contentOfStandardFooter','footerElement','footerBodyItem']
    if (footerContent) {
      if (typeof footerContent.element === 'object') {
        type = footerContent.element.tag ? 'footerBodyItem' : 'footerElement';
      } else if (typeof footerContent === 'string') {
        let uu5JsonRegEx = /(^<uu5json\/>)/;
        let match = uu5JsonRegEx.exec(footerContent);
        type = (match) ? 'uu5JSON' : 'contentOfStandardFooter';
      } else {
        type = 'contentOfStandardFooter';
      }
    }
    return type;
  },

  getUU5_Common_SectionMixinProps: function () {
    return {
      header: this.getHeader(),
      footer: this.getFooter()
    };
  },

  getUU5_Common_SectionMixinPropsToPass: function () {
    return Tools.mergeDeep({}, this.getUU5_Common_SectionMixinProps(), this.getUU5_Common_ContentMixinPropsToPass(), this.getUU5_Common_LevelMixinPropsToPass());
  },

  registerRenderedHeaderChild: function (renderedHeaderChild) {
    if (renderedHeaderChild.hasUU5_Common_BaseMixin) {
      this.renderedHeaderChild = renderedHeaderChild;
    }
    return this;
  },

  registerRenderedFooterChild: function (renderedFooterChild) {
    if (renderedFooterChild.hasUU5_Common_BaseMixin) {
      this.renderedFooterChild = renderedFooterChild;
    }
    return this;
  },

  expandHeaderProps: function (prevHeaderChild) {
    var newHeaderChildProps = prevHeaderChild.props;
    newHeaderChildProps = Tools.mergeDeep({}, newHeaderChildProps);
    newHeaderChildProps.parent = this;
    newHeaderChildProps.id = newHeaderChildProps.id || this.getId() + '-header';

    this.props.containerStyle && (newHeaderChildProps.containerStyle = this.props.containerStyle);
    this.props.colWidth && (newHeaderChildProps.colWidth = this.props.colWidth);

    if (typeof this.expandHeaderProps_ === 'function') {
      var tempHeaderChild = this.cloneChild(prevHeaderChild, newHeaderChildProps);
      newHeaderChildProps = this.expandHeaderProps_(tempHeaderChild);
    }

    newHeaderChildProps.key = newHeaderChildProps.id;

    newHeaderChildProps.ref = function (renderedChild) {
      renderedChild && this.registerRenderedHeaderChild(renderedChild);
    }.bind(this);

    return newHeaderChildProps;
  },

  expandFooterProps: function (prevFooterChild) {
    var newFooterChildProps = prevFooterChild.props;
    newFooterChildProps = Tools.mergeDeep({}, newFooterChildProps);
    newFooterChildProps.parent = this;
    newFooterChildProps.id = newFooterChildProps.id || this.getId() + '-footer';

    this.props.containerStyle && (newFooterChildProps.containerStyle = this.props.containerStyle);
    this.props.colWidth && (newFooterChildProps.colWidth = this.props.colWidth);

    if (typeof this.expandFooterProps_ === 'function') {
      var tempFooterChild = this.cloneChild(prevFooterChild, newFooterChildProps);
      newFooterChildProps = this.expandFooterProps_(tempFooterChild);
    }

    newFooterChildProps.key = newFooterChildProps.id;

    newFooterChildProps.ref = function (renderedChild) {
      renderedChild && this.registerRenderedFooterChild(renderedChild);
    }.bind(this);

    return newFooterChildProps;
  },

  buildHeaderChild: function (header) {
    header = header || this.getHeader();

    var headerChild = null;

    if (typeof this.buildHeaderChild_ === 'function') {
      headerChild = this.buildHeaderChild_(header);
    } else {

      var headerValue = header;
      var headerType = this.getHeaderType(headerValue);

      if (headerType === 'uu5JSON') {
        headerValue = Tools.parseFromUu5JSON(headerValue);
        headerType = this.getHeaderType(headerValue);
      }

      switch (headerType) {
        case 'headerBodyItem':
          headerChild = this.buildChild(headerValue.element.tag, headerValue.element.props);
          headerChild = this.cloneChild(headerChild, this.expandHeaderProps(headerChild));
          break;
        case 'headerElement':
          headerChild = headerValue.element;
          headerChild = this.cloneChild(headerChild, this.expandHeaderProps(headerChild));
          break;
        case 'contentOfStandardHeader':
          headerChild = this.buildChild(this.getDefault('headerTag', 'UU5_Common_SectionMixin'), { content: headerValue });
          headerChild = this.cloneChild(headerChild, this.expandHeaderProps(headerChild));
          break;
        default:
        // there is no header
      }
    }
    return headerChild;
  },

  buildFooterChild: function (footer) {
    footer = footer || this.getFooter();

    var footerChild = null;

    if (typeof this.buildFooterChild_ === 'function') {
      footerChild = this.buildFooterChild_(footer);
    } else {


      var footerValue = footer;
      var footerType = this.getFooterType(footerValue);

      if (footerType === 'uu5JSON') {
        footerValue = Tools.parseFromUu5JSON(footerValue);
        footerType = this.getFooterType(footerValue);
      }

      switch (footerType) {
        case 'footerBodyItem':
          footerChild = this.buildChild(footerValue.element.tag, footerValue.element.props);
          footerChild = this.cloneChild(footerChild, this.expandFooterProps(footerChild));
          break;
        case 'footerElement':
          footerChild = footerValue.element;
          footerChild = this.cloneChild(footerChild, this.expandFooterProps(footerChild));
          break;
        case 'contentOfStandardFooter':
          footerChild = this.buildChild(this.getDefault('footerTag', 'UU5_Common_SectionMixin'), { content: footerValue });
          footerChild = this.cloneChild(footerChild, this.expandFooterProps(footerChild));
          break;
        default:
        // there is no footer
      }
    }
    return footerChild;
  },

  getHeaderChild: function () {
    return this.buildHeaderChild();
  },

  getFooterChild: function () {
    return this.buildFooterChild();
  },

  getRenderedHeaderChild: function () {
    return this.renderedHeaderChild;
  },

  getRenderedFooterChild: function () {
    return this.renderedFooterChild;
  }
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

};

export default SectionMixin;



// WEBPACK FOOTER //
// ./common/section-mixin.js